import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import "./style_v2.css";
import "../../../../../index.css";
class IntelligentSearchBoxV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { handleVisibleFilter, schoolFilter } = this.props;
    return (
      <div className="intelligentV2_search_box">
        <div className="intelligentV2_search_box_left fl">
          {schoolFilter.schoolName !== "" || schoolFilter.majorName !== "" ? (
            <div>
              <div>
                <NavLink
                  to="/intelligentbigdata/search?type=school"
                  className="intelligentV2_search_box_left_div  fl"
                >
                  <div className="intelligentV2_search_box_left_div_input">
                    <input
                      placeholder={
                        schoolFilter.schoolName !== ""
                          ? "搜大学：" + schoolFilter.schoolName
                          : "搜大学"
                      }
                      readOnly
                    ></input>
                  </div>
                </NavLink>
                <NavLink
                  to="/intelligentbigdata/search?type=major"
                  className="intelligentV2_search_box_left_div  fl"
                >
                  <div className="intelligentV2_search_box_left_div_input">
                    <input placeholder={
                        schoolFilter.majorName !== ""
                          ? "搜专业：" + schoolFilter.majorName
                          : "搜专业"
                      } readOnly></input>
                  </div>
                </NavLink>
              </div>
            </div>
          ) : (
            <div>
              <NavLink
                to="/intelligentbigdata/search?type=school"
                className="intelligentV2_search_box_left_div  "
              >
                <div className="intelligentV2_search_box_left_div_input">
                  <input placeholder="搜大学" readOnly></input>
                </div>
              </NavLink>
              <NavLink
                to="/intelligentbigdata/search?type=major"
                className="intelligentV2_search_box_left_div  "
              >
                <div className="intelligentV2_search_box_left_div_input">
                  <input placeholder="搜专业" readOnly></input>
                </div>
              </NavLink>
            </div>
          )}
        </div>
        <div
          onClick={() => handleVisibleFilter()}
          className="intelligentV2_search_box_right fl"
        >
          <div className="intelligentV2_search_box_right_img fl">
            <img
              alt=""
              src={require("../../../../../images/search/search_1.png")}
            ></img>
          </div>
          <div className="intelligentV2_search_box_right_txt fl">筛选</div>
        </div>
        <div className="clear"></div>
      </div>
    );
  }
}

export default IntelligentSearchBoxV2;



// WEBPACK FOOTER //
// ./src/containers/IntelligentBigData/IntelligentBigDataHome/components/IntelligentSearchBox/index_v2.js